import { licenceOf, resolutionText, findTime } from '../catalogue';
import type { SourceDef } from '../types';
import { Sheet } from './sheet';
import { clear, el } from './dom';

function row(label: string, value: Node | string): HTMLElement {
  return el('div', { class: 'info-row' }, [
    el('dt', { text: label }),
    el('dd', {}, [typeof value === 'string' ? document.createTextNode(value) : value]),
  ]);
}

export class InfoSheet {
  readonly sheet = new Sheet('O zdroji');

  show(def: SourceDef, timeId?: string): void {
    const lic = licenceOf(def);
    const time = timeId ? findTime(def, timeId) : undefined;
    clear(this.sheet.body);
    this.sheet.setTitle(def.title);

    const endpoint = el('code', { class: 'info-endpoint', text: def.url });
    const copy = el('button', {
      class: 'info-copy',
      attrs: { type: 'button' },
      text: 'Kopírovat adresu služby',
      on: {
        click: () => {
          void navigator.clipboard?.writeText(def.url).then(
            () => (copy.textContent = 'Zkopírováno'),
            () => (copy.textContent = 'Kopírování se nezdařilo'),
          );
        },
      },
    });

    const licenceLink = el('a', {
      class: lic.free ? 'info-licence' : 'info-licence is-restricted',
      text: lic.label,
      attrs: { href: lic.url, target: '_blank', rel: 'noreferrer noopener' },
    });

    const blocks: (Node | null)[] = [
      el('dl', { class: 'info-grid' }, [
        row('Rozlišení', resolutionText(def, timeId)),
        time ? row('Zvolený rok', `${time.label}${time.note ? ` — ${time.note}` : ''}`) : null,
        row('Datum / cyklus', def.dateText),
        def.accuracyText ? row('Přesnost', def.accuracyText) : null,
        row('Poskytovatel', def.provider),
        row('Licence', licenceLink),
        lic.warn ? row('Pozor', lic.warn) : null,
        row('Atribuce', def.attribution),
        row('Nativní projekce', `${def.projection}${def.reproject ? ' (přepočítáno v prohlížeči)' : ''}`),
        row('Zoom', `${def.minZoom ?? 0}–${def.maxZoom ?? 22}`),
        row('Typ služby', def.type),
      ]),
      def.warnText ? el('p', { class: 'info-warn', text: `⚠ ${def.warnText}` }) : null,
      def.caveats?.length
        ? el('ul', { class: 'info-caveats' }, def.caveats.map((c) => el('li', { text: c })))
        : null,
      el('div', { class: 'info-endpoint-wrap' }, [endpoint, copy]),
      el('p', {
        class: 'info-note',
        text:
          'Dlaždice si prohlížeč stahuje přímo od poskytovatele. Tento web je jen statická ' +
          'stránka — žádná data neprocházejí naším serverem.',
      }),
    ];
    this.sheet.body.append(...blocks.filter((b): b is Node => b !== null));

    this.sheet.setSnap('half');
  }
}
